import { render, staticRenderFns } from "./custom_license_list.vue?vue&type=template&id=c79e8448&scoped=true&"
import script from "./custom_license_list.vue?vue&type=script&lang=js&"
export * from "./custom_license_list.vue?vue&type=script&lang=js&"
import style0 from "./custom_license_list.vue?vue&type=style&index=0&id=c79e8448&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c79e8448",
  null
  
)

export default component.exports